import { CartScreen } from '@fhs/cart';

export default CartScreen;
